module.exports = __webpack_public_path__ + "static/1-f4825ecb44d1216a2580e22949d904e0.png";